module.exports = __webpack_public_path__ + "static/media/folders.cdc5d1c0.svg";